import React, { useState } from 'react';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import Pagination from 'components/shared/pagination';
import { setQueryString } from 'utils/url';
import { Spinner } from 'ui';
import AttemptsList from './AttemptsList';
import Attempts from './Attempts';
import PreviousAttemptWithResponses from '../../shared/PreviousAttemptWithResponses';

const LearnerOverview = ({ scenarioId, userId }) => {
  const [page, setPage] = useState(1);
  const attemptUrl = setQueryString(
    routes.ON_DEMAND_PRACTICE.CREATOR.ATTEMPTS.USER(scenarioId, userId),
    { page },
  );
  const { data = {}, loading, error: loadError } = useFetch(attemptUrl);
  const {
    attempts,
    containerTitle,
    hippoPreviewBase,
    hippoThumbnailBase,
    pagination,
    scenarioType,
    userName,
    ziggeoApiKey,
  } = data;

  const setCurrentPage = newPage => {
    setPage(newPage);
  };

  const renderPreviousAttempts = () => {
    if (scenarioType === 'conversation') {
      return (
        <>
          {attempts.map(attempt => (
            <PreviousAttemptWithResponses attempt={attempt} hideExplanations />
          ))}
        </>
      );
    }

    return (
      <Attempts
        attempts={attempts}
        hippoPreviewBase={hippoPreviewBase}
        hippoThumbnailBase={hippoThumbnailBase}
        ziggeoApiKey={ziggeoApiKey}
      />
    );
  };

  return (
    <section className="LearnerOverview">
      {loadError && (
        <div className="fz-24 w-half m-a ta-c">
          {t('practice.on_demand_practice.error.generic')}
        </div>
      )}
      {loading && <Spinner />}
      {!loading && (
        <div>
          <h1 className="LearnerOverview-header">
            {t(
              'practice.on_demand_practice.overview.learner_page.for_the_learner',
            )}
            <a href={routes.USER(userId)} className="td-u">
              {userName}
            </a>
            {t(
              'practice.on_demand_practice.overview.learner_page.and_the_scenario',
            )}
            <a
              href={routes.ON_DEMAND_PRACTICE.CREATOR.SHOW(scenarioId)}
              className="td-u"
            >
              {containerTitle}
            </a>
          </h1>
          <AttemptsList attempts={attempts} userName={userName} />
          <div className="fz-18 mt-30">
            {t(
              'practice.on_demand_practice.overview.learner_page.completed_responses',
            )}
          </div>
          <div className="mt-24">{renderPreviousAttempts()}</div>
          {pagination.pages > 1 && (
            <Pagination
              pages={pagination.pages}
              pageSelectCallback={setCurrentPage}
              selected={pagination.selected}
            />
          )}
        </div>
      )}
    </section>
  );
};
export default props => <LearnerOverview {...props} />;
